<template>
    <section class="ui-advantages">
        <h2 class="h2 ui-advantages__title">{{ title }}</h2>
        <div class="ui-advantages-wrapper">
            <UIAdvantage
                v-for="advantage in advantages"
                :key="advantage.iconSrc"
                :advantage="advantage"
            />
        </div>
    </section>
</template>

<script>
import {defineComponent} from 'vue';
import UIAdvantage from './UIAdvantage.vue';

export default defineComponent({
    name: 'UIAdvantages',
    components: {
        UIAdvantage,
    },
    props: {
        advantages: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            default: () => 'Преимущества',
        },
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/ui-elements/ui-advantages/index';
</style>
